// Constants for different requests for current reducer
export default {
  mainLayout: 'MAIN_LAYOUT',
};
